import ascending from "./ascending.js";
import minIndex from "./minIndex.js";
export default function leastIndex(values, compare) {
    if (compare === void 0) { compare = ascending; }
    if (compare.length === 1)
        return minIndex(values, compare);
    var minValue;
    var min = -1;
    var index = -1;
    for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
        var value = values_1[_i];
        ++index;
        if (min < 0
            ? compare(value, value) === 0
            : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}
